<template>
    <div class="heritagemark">
        <PageTitle icon="fa fa-clone" main="Registro" sub="Marca/Modelo" />
         <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input 
                id="heritagemark-id" 
                type="hidden" 
                v-model="heritagemark.id" />
             <b-row>
                <b-col md="9" sm="12">
                  <b-form-group 
                      label="Marca:" 
                      label-for="heritagemark-heritage_mark_name">
                      <b-form-input 
                          id="heritagemark-heritage_mark_name" 
                          type="text"
                          v-model="heritagemark.heritage_mark_name" 
                          size="sm"
                          ref="focusadd"
                          :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                          placeholder="Nome..." />
                  </b-form-group>
                </b-col>    
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="heritagemark.blocked" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="heritagemark-blocked"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="heritagemark-blocked">
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col> 
             </b-row>
         </b-form>
              <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12" class="sub-background">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                        </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                         :class="icon" 
                         @click="[loadHeritageMarks(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
           <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            ref="searchFocus"
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Informe a descrição" 
                            class="form-control">
                    </div>
                </div>
     
                <b-row>
                     <b-col md="6" sm="12" >   
                        <transition  name="slide" type="animation" appear>       
                            <b-table 
                                 :busy="isBusy"  
                                class="table-responsive"  
                                v-show="showTable" 
                                hover 
                                key="slide" 
                                 head-variant="light" 
                                :per-page="perPage" 
                                :current-page="currentPage" 
                                :items="filteredList" 
                                :fields="fields">
                                <template v-slot:cell(actions)="data">
                                        <b-button  
                                            title = "Detalhe do registro" 
                                            size="sm" 
                                            variant="light" 
                                            @click="loadHeritageMark(data.item, 'read')" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-drivers-license-o"></i>
                                        </b-button>
                                        <b-button  
                                             title = "Editar registro" 
                                            size="sm" 
                                            variant="light" 
                                            @click="loadHeritageMark(data.item)" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button  
                                             
                                            title = "Excluir registro" 
                                            size="sm" 
                                            variant="light" 
                                            @click="loadHeritageMark(data.item, 'remove')" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                        <b-button  
                                              
                                            v-b-modal.modalModel 
                                            title = "Adicionar Modelo Patrimonial" 
                                            size="sm" 
                                            variant="light" 
                                            @click="actionNewModel(data.item)" 
                                            class="mr-2 mt-2">
                                                <i class="fa fa-plus"></i>
                                        </b-button>
                                        <b-button 
                                             
                                            title = "Listar Modelo Patrimonial" 
                                            size="sm" 
                                            variant="light" 
                                            @click="setModel(data.item)" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-tasks"></i>
                                        </b-button> 
                                    </template>   
                            </b-table>    
                        </transition>
                        <transition  name="slide" type="animation" appear>
                            <b-pagination
                                v-show="showTable"
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                                size="sm"
                                aria-controls="my-table"
                            ></b-pagination>
                        </transition>
                    </b-col>
                     <b-col  md="6" sm="12" >   
                        <transition  
                            name="slide" 
                            type="animation" 
                            appear>       
                            <b-table 
                                class="table-responsive"  
                                v-show="showTableModel" 
                                hover key="slide" 
                                striped 
                                :items="heritagemarksmodels" 
                                :fields="fieldsModel">
                                <template v-slot:cell(actions)="data">
                                        <b-button   
                                            v-b-modal.modalModel 
                                            title = "Editar registro" 
                                            size="sm" 
                                            variant="light" 
                                            @click="loadHeritageMarkModel(data.item)" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button   
                                            size="sm" 
                                            variant="light" 
                                            @click="modeModel = 'remove'" 
                                            class="mr-2 mt-2"
                                            v-if="modeModel === 'insert'">
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                        <b-button   
                                            size="sm" 
                                            variant="light" 
                                            @click="[removeModel(data.item),modeModel = 'insert']" 
                                            class="mr-2 mt-2"
                                            v-if="modeModel === 'remove'"
                                        >
                                            <i class="fa fa-check"></i>
                                        </b-button>
                                        <b-button   
                                            size="sm" 
                                            variant="light" 
                                            @click="modeModel = 'insert'" 
                                            class="mr-2 mt-2"
                                            v-if="modeModel === 'remove'"
                                        >
                                            <i class="fa fa-times"></i>
                                        </b-button>
                                        <span class="mr-2 mt-2"  
                                            v-if="modeModel === 'remove'" >Deseja Excluir o registro?</span>
                                                        
                                </template>   
                            </b-table>    
                        </transition>
                    </b-col>
                </b-row>   

        <b-modal id="modalModel"
            ref="modal"
            title-tag = "h6"
            size="lg"
            title="Modelo Patrimonial"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveModel"
            >
           <b-form>
               <b-row>
                <b-col md="9" sm="12">
                  <b-form-group 
                      label="Modelo:" 
                      label-for="heritagemarksmodel-heritage_mark_model_name">
                      <b-form-input 
                          id="heritagemarksmodel-heritage_mark_model_name" 
                          type="text"
                          v-model="heritagemarksmodel.heritage_mark_model_name" 
                          size="sm"
                          ref="focusadd"
                          
                          placeholder="Nome..." />
                  </b-form-group>
                </b-col>    
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="heritagemarksmodel.blocked" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="heritagemarksmodel-blocked"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="heritagemarksmodel-blocked">
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col> 
             </b-row>
           </b-form>

        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'HeritageMark',
    components: {PageTitle},
    data: function() {
        return {
            mode: 'insert',
            modeModel: 'insert',
            search: '',
            heritagemark: {},
            heritagemarks: [],
            heritagemarksmodel: {},
            heritagemarksmodels: [],
            showTable: false,
            showTableModel: false,
            isBusy: false,
            perPage: 5,
            currentPage: 1,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            fields: [
                { key: 'heritage_mark_name', label: 'Marca', sortable: true },
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' }, 
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsModel: [
                { key: 'heritage_mark_model_name', label: 'Modelo', sortable: true },
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' }, 
                { key: 'actions', label: 'Ações', variant: 'light' }
            ]
        }
    },
     computed:
        {  
        user(){
            return this.$store.state.user
        },
        filteredList() {
            return this.heritagemarks.filter(heritagemark => {
            return heritagemark.heritage_mark_name.toLowerCase().includes(this.search.toLowerCase())
                })
        },
        icon() {
            return this.showTable ? "fa-retweet" : "fa-search"
        },
        rows() {
            return this.heritagemarks.length
        },
    },
    methods: {
        async loadHeritageMarks() {
            const url = `${baseApiUrl}/heritagemarks`
            await axios.get(url).then(res => {
                this.heritagemarks = res.data
                this.isBusy = false
            })
        },
        async loadHeritageMarkModels() {
            const url = `${baseApiUrl}/heritagemarksmodels/${this.heritagemark.id}/heritagemark`
            await axios.get(url).then(res => {
                this.heritagemarksmodels = res.data
            })
        },
        async reset() {
            this.mode = 'insert'
            await this.loadHeritageMarks()
            this.heritagemarksmodels = []
        },
         toggleBusy() {
          this.isBusy = !this.isBusy
         },
        alterModo() {
                    this.mode = 'save'
                    this.heritagemark = {}      
            }, 
        async save() {
            const method = this.heritagemark.id ? 'put' : 'post'
            const id = this.heritagemark.id ? `/${this.heritagemark.id}` : ''
            this.heritagemark.user_id = this.user.id
            await axios[method](`${baseApiUrl}/heritagemarks${id}`, this.heritagemark)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async saveModel() {
            const method = this.heritagemarksmodel.id ? 'put' : 'post'
            const id = this.heritagemarksmodel.id ? `/${this.heritagemarksmodel.id}` : ''

            this.heritagemarksmodel.user_id = this.user.id
            this.heritagemarksmodel.heritage_mark_id = this.heritagemark.id
            await axios[method](`${baseApiUrl}/heritagemarksmodels${id}`, this.heritagemarksmodel)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadHeritageMarkModels()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.heritagemark.id
            await axios.delete(`${baseApiUrl}/heritagemarks/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
       async removeModel(model) {
            const id = model.id
            await axios.delete(`${baseApiUrl}/heritagemarksmodels/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadHeritageMarkModels()
                })
                .catch(showError)
        },
        loadHeritageMark(heritagemark, mode = 'save') {
            this.mode = mode
            this.heritagemark = { ...heritagemark }

        },
        loadHeritageMarkModel(heritagemarksmodel) {
            this.heritagemarksmodel = { ...heritagemarksmodel }
        },
       async actionNewModel(heritagemark){
            this.heritagemark = { ...heritagemark }
            this.heritagemarksmodel = {}
            await this.loadHeritageMarkModels()
            this.showTableModel = true
        },
        async setModel(heritagemark){
            this.heritagemark = { ...heritagemark }
            this.heritagemarksmodel = {}
            await this.loadHeritageMarkModels()
            this.showTableModel = true
        },
        focusAdd(){
            this.$refs.focusadd.focus()
        },
        focusSearch(){
            this.$refs.inputsearch.focus()
        },
    },
   async mounted() {
       await this.loadHeritageMarks()
        this.showTable = true
        this.$refs.inputsearch.focus();
    }
}
</script>

<style>

    .sub-background{
      background:linear-gradient(to top, #bdc3c7, #e7ebee);
      border-radius: 35px ;
    }


     .heritagemark {
        font-size: 0.7rem;
    }


    .heritagemark input,label,form{
        font-size: 0.7rem;
    }
    .heritagemark button{
        font-size: 0.7rem;
    }

    .heritagemark select{
        font-size: 0.7rem;
    }

    .heritagemark table{
        font-size: 0.7rem;
    }

     #modalModel {
        font-size: 0.7rem;
    }

    #modalModel input{
        font-size: 0.7rem;
    }

    #modalModel button{
        font-size: 0.7rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
